import React from 'react';
import PartnerRow from './PartnerRow';
import PropTypes from 'prop-types';

const PartnerRows = (props) => {
     return (
        <div className='partner-rows'>
           {props.rows.map(row => {
               let currency = [];

               row.forEach(tariff => {
                   currency.push(tariff.toCurrency)
               })

               const targetValues = row.map(item => {
                    return {
                        minTransferAmount: item.minTransferAmount,
                        maxTransferAmount: item.maxTransferAmount,
                        commissionPercent: item.commissionPercent, 
                        minCommissionAmountInToCcy: item.minCommissionAmountInToCcy,
                        partnerInfoDto: item.partnerInfoDto,
                        partnerName: item.partnerInfoDto ? item.partnerInfoDto.partnerName : '',
                        isActive: item.partnerInfoDto ? item.partnerInfoDto.isActive : '',
                        name: item.partnerInfoDto ? item.partnerInfoDto.partnerType.name : ''
                    }
                })
                const stringifyTargetValues = targetValues.map(item => JSON.stringify(item));
                const isEqual = stringifyTargetValues.every(elem => elem === stringifyTargetValues[0]);
                
                if (isEqual) {
                    return <PartnerRow row={row[0]} key={row[0].id} currency={currency}
                                       defaultStaticContentTariffs={props.defaultStaticContentTariffs}
                                       direction={props.direction}
                                       activeLangStaticContentTariffs={props.activeLangStaticContentTariffs}/>
                } else {
                    return row.map(partner => {
                        return <PartnerRow row={partner} key={partner.id}
                                            direction={props.direction}
                                            defaultStaticContentTariffs={props.defaultStaticContentTariffs}
                                            activeLangStaticContentTariffs={props.activeLangStaticContentTariffs}/>
                    })
                }
            })
        }
        </div>
    )  
}

export default PartnerRows;

PartnerRows.propTypes = {
    rows: PropTypes.array.isRequired,
    defaultStaticContentTariffs: PropTypes.object,
    activeLangStaticContentTariffs: PropTypes.object,
    direction: PropTypes.string.isRequired,
}